// entorno/AuthContext.js
import { createContext, useContext, useState } from "react";

// 1. Crear el contexto
const AuthContext = createContext();

// 2. Hook personalizado
export const useAuth = () => useContext(AuthContext);

// 3. Proveedor
export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);

  const login = (usuarioData) => setUsuario(usuarioData);
  const logout = () => setUsuario(null);

  return (
    <AuthContext.Provider value={{ usuario, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
